import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminInput from "components/admin/input"
import debounce from "debounce"
import memo from "set-state-compare/build/memo"
import Params from "@kaspernj/api-maker/build/params"
import PropTypes from "prop-types"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

const freeTextSearchKey = [
  "current_translation_name",
  "first_name",
  "last_name",
  "primary_email_email",
  "primary_phone_number_phone_number",
  "parents_current_translation_name_cont_any_word"
].join("_or_")

/**
 * @typedef {object} ComponentsContactsTableSearchProps
 * @property {object} qParams
 */

/** @typedef {object} ComponentsContactsTableSearchState */

/**
 * @extends {ShapeComponent<ComponentsContactsTableSearchProps, ComponentsContactsTableSearchState>}
 */
class ComponentsContactsTableSearch extends ShapeComponent {
  static propTypes = {
    qParams: PropTypes.object
  }

  setup() {
    const {t} = useI18n({namespace: "js.shared"})
    const {qParams} = this.p
    const onChangeText = useMemo(
      () =>
        debounce((value) => {
          const nextQParams = Params.setUndefined({
            ...qParams,
            [freeTextSearchKey]: value
          })

          Params.changeParams({
            contacts_page: undefined,
            contacts_q: nextQParams ? JSON.stringify(nextQParams) : undefined
          })
        }, 300),
      [qParams]
    )

    this.onChangeText = onChangeText
    this.t = t
  }

  render() {
    const currentValue = this.p.qParams?.[freeTextSearchKey] || ""

    return (
      <View
        style={this.searchContainerStyle ||= {marginRight: 10, minWidth: 280}}
        testID="admin-contacts-search-container"
      >
        <AdminInput
          defaultValue={currentValue}
          label={this.tt.t(".search")}
          onChangeText={this.tt.onChangeText}
          placeholder={this.tt.t(".search")}
          testID="admin-contacts-search-input"
        />
      </View>
    )
  }
}

export default memo(shapeComponent(ComponentsContactsTableSearch))
